import { EditableGeoJsonLayer } from "@nebula.gl/layers";
import { MeasureDistanceMode } from "@nebula.gl/edit-modes";

export default class DistanceToolLayer {
  constructor({ layer_id, data, updateState }) {
    this.layer_id = layer_id;
    this.layer = this.generateLayer(data);
    this.data = data;
    this.selectedFeatureIndexes = [];
    this.updateState = updateState;
  }

  generateLayer(data) {
    return new EditableGeoJsonLayer({
      id: this.layer_id,
      data: data,
      mode: MeasureDistanceMode,
      selectedFeatureIndexes: this.selectedFeatureIndexes,
      getLineColor: d => [255, 255, 255],
      getColor: d => [255, 255, 255],
      getFillColor: d => [255, 255, 255],
      getEditHandlePointColor: d => [255, 255, 255],
      getEditHandleIconColor: d => [255, 255, 255],
      _subLayerProps: {
        tooltips: {
          getColor: [255, 255, 255],
        },
      },
      onEdit: ({ updateData }) => {
        this.updateState(updateData);
      },
    });
  }

  getLayer() {
    return this.layer;
  }
}
